export default __webpack_public_path__ + "assets/drag.ae4fe748.svg";